import { useCallback, useEffect, useRef, useState } from 'react';
import proofApi from 'src/features/proofs/api';
import { IProof } from 'src/ts/interfaces';

export const useFreshPdfUrl = (
  proofId: string | undefined,
  storedUrl: string | null | undefined
) => {
  const key = `${proofId}|${storedUrl}`;
  const [retryKey, setRetryKey] = useState<string | null>(null);
  const [fresh, setFresh] = useState<{ key: string; url: string | null } | null>(null);
  const retried = useRef<string | null>(null);

  useEffect(() => {
    if (retryKey !== key || !proofId) return undefined;
    let cancelled = false;
    proofApi
      .getProofById(proofId)
      .then((response) => {
        const file = (response?.data as IProof | undefined)?.file;
        if (!cancelled) setFresh({ key, url: file ?? storedUrl ?? null });
      })
      .catch(() => {
        if (!cancelled) setFresh({ key, url: storedUrl ?? null });
      });
    return () => {
      cancelled = true;
    };
  }, [retryKey, key, proofId, storedUrl]);

  const retry = useCallback(() => {
    if (!proofId || retried.current === key) return false;
    retried.current = key;
    setRetryKey(key);
    return true;
  }, [proofId, key]);

  if (retryKey !== key) return { url: storedUrl ?? null, retry };
  return { url: fresh?.key === key ? fresh.url : undefined, retry };
};
